import React from "react";
import becomeMentor1 from "../assets/images/becomeMentor1.png";
import becomeMentor2 from "../assets/images/becomeMentor2.png";
import becomeMentor3 from "../assets/images/becomeMentor3.png";
import becomeMentor4 from "../assets/images/becomeMentor4.png";

function Cards() {
  const cardInfo = [
    {
      id: 1,
      name: "Learn",
      description:
        "A mentor is someone who helps you grow your skills, make better decisions, and gain new perspectives on your life and career.",
      image: becomeMentor1,
    },
    {
      id: 2,
      name: "Grow",
      description:
        "Being a mentor serves as a way to give back and is an important development and learning experience. Teaching others is the best way to learn yourself.",
      image: becomeMentor2,
    },
    {
      id: 3,
      name: "A diverse community",
      description:
        "A successful community in which individuals bring their different knowledge, experience and interest for the benefit of their diverse community.",
      image: becomeMentor3,
    },
    {
      id: 4,
      name: "Opportunities to impact",
      description:
        "The mentor can impart wisdom developed on the job over time, or policies that will help the mentee succeed in the long run.",
      image: becomeMentor4,
    },
  ];

  return (
    <div>
      <div class="container px-5 pt-12 mx-auto">
        <div class="flex flex-wrap -m-4">
          {cardInfo.map((data) => (
            <div class="p-4 md:w-1/2 w-full">
              <div class="w-full rounded-lg px-2 mx-auto relative overflow-hidden bg-blue-50">
                <div class="my-4 mx-2 relative ">
                  <div class=" p-4 bg-white/40 backdrop-blue-md rounded-3xl">
                    <div class="my-4 flex">
                      <div className="sm:flex">
                        <img
                          src={data.image}
                          class="rounded-lg"
                          alt="mentors features"
                          height={150}
                          width={150}
                        />
                        <div className="sm:ml-4 flex flex-col mt-8 sm:mt-0">
                          <div>
                            <h2 class="text-2xl font-semibold">{data.name}</h2>
                          </div>
                          <h3 class="mt-4 sm:mt-4 text-md text-black">
                            {data.description}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Cards;
